<template>
  <div>
    <div class="my-10 w-100 text-right">
      <v-alert
        text
        type="success"
        border="left"
        v-if="succeed"
        v-model="alert"
        dismissible
      >
        <strong>تراکنش با موفقیت انجام شد .</strong>
      </v-alert>
      <v-alert
        text
        type="error"
        border="left"
        v-else-if="!succeed"
        v-model="alert"
        dismissible
      >
        <strong>تراکنش ناموفق </strong>
      </v-alert>
    </div>
    <v-card
      outlined
      v-if="succeed && paymentId"
      class="text-right"
    >
      <v-card-title>
        {{ onlinePayment.paymentMethodTitle }}
      </v-card-title>
      <v-card-text>
        <div>
          <strong>
            {{ onlinePayment.description }}
          </strong>
        </div>
        <div>
          <label for=""> تاریخ : </label>
          <strong>
            {{ onlinePayment.dateOfActionUtc | moment }}
          </strong>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const paymentRepository = () => RepoFactory.get('payment');
import Helper from '@/core/helpers';
export default {
  props: {
    succeed: {
      default: undefined,
      type: Boolean,
    },
    paymentId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      alert: true,
      onlinePayment: null,
    };
  },
  created() {
    if (this.paymentId) {
      this.getOnlinePaymentById();
    }
  },
  methods: {
    getOnlinePaymentById() {
      paymentRepository()
        .getOnlinePaymentById(
          this.$store.getters.paymentBaseUrl,
          {},
          {
            paymentId: this.paymentId,
          }
        )
        .then((res) => {
          this.onlinePayment = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
  },
};
</script>

<style></style>
